import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { Link } from 'gatsby';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import TwitterIcon from '@material-ui/icons/Twitter';
import LanguageIcon from '@material-ui/icons/Language';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      fontWeight: 'bold',
      fontSize: '1em',
    },
    primary: { color: 'white', textDecoration: 'none' },
    link: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    avatar: {
      backgroundColor: 'transparent',
      paddingRight: '0px',
    },
    item: {
      padding: '0px 0px 0px 16px',
    },
    mainItem: {
      marginTop: '0px',
      marginBottom: '0px',
    },

    textSecondary: {
      // marginLeft: '10px',
      marginBottom: '0px',
      fontSize: '1em',
    },
  }),
);

export const mainListItems = () => {
  const classes = useStyles();
  return (
    <div>
      <Link to="/report#foreword" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Foreword</Typography>}
          />
        </ListItem>
      </Link>
      <Link to="/report#fundingfigures" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Funding figures</Typography>}
          />
        </ListItem>
      </Link>
      <Link to="/report#globalreportfoodcrises" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Global report on food crises</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#savinglives" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Saving lives</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#fatou" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            secondary={<Typography className={classes.textSecondary}>Fatou’s Story</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#bringinghope" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Bringing hope and stability</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#map" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Countries receiving funding</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#changinglives" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Changing lives</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#joyce" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            secondary={<Typography className={classes.textSecondary}>Joyce's story</Typography>}
          />
        </ListItem>
      </Link>

      <Link to="/report#kenya" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            secondary={
              <Typography className={classes.textSecondary}>Addressing Food Needs</Typography>
            }
          />
        </ListItem>
      </Link>

      <Link to="/report#chad" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            secondary={
              <Typography className={classes.textSecondary}>Accelerating in Chad</Typography>
            }
          />
        </ListItem>
      </Link>

      <Link to="/report#innovation" className={classes.primary}>
        <ListItem button className={classes.mainItem}>
          <ListItemText
            className={classes.primary}
            primary={<Typography className={classes.text}>Innovation &amp; logistics</Typography>}
          />
        </ListItem>
      </Link>
    </div>
  );
};

export const secondaryListItems = () => {
  const classes = useStyles();
  return (
    <div className={classes.link}>
      <a href="https://twitter.com/WFP_Europe" target="_blank" className={classes.primary}>
        <ListItem className={classes.item}>
          <Avatar className={classes.avatar}>
            <TwitterIcon />
          </Avatar>
        </ListItem>
      </a>
      <a href="https://wfp.org" target="_blank" className={classes.primary}>
        <ListItem className={classes.item}>
          <Avatar className={classes.avatar}>
            <LanguageIcon />
          </Avatar>
        </ListItem>
      </a>
    </div>
  );
};
